// extracted by mini-css-extract-plugin
export default {"line":"vertical-line_line__85+5N"};